import { render, staticRenderFns } from "./ViewGallery.vue?vue&type=template&id=4de90bf7&scoped=true"
import script from "./ViewGallery.vue?vue&type=script&lang=js"
export * from "./ViewGallery.vue?vue&type=script&lang=js"
import style0 from "./ViewGallery.vue?vue&type=style&index=0&id=4de90bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de90bf7",
  null
  
)

export default component.exports